document.addEventListener("DOMContentLoaded", function() {
  const form = document.getElementById("access-form");
  const input = document.getElementById("access-password");
  const error = document.getElementById("error-message");

  // 🔑 Mot de passe configuré
  const PASSWORD = "SECRET";
  const REDIRECT_URL = "/collections/bucolik-private-protected";

  // Vérifie si la session est déjà autorisée
  try {
    if (sessionStorage.getItem("bucolikAccess") === "granted") {
      window.location.href = REDIRECT_URL;
      return;
    }
  } catch (e) {
    // Dans certains navigateurs en mode strict, sessionStorage peut lever une exception
    console.warn('sessionStorage inaccessible', e);
  }

  if (!form) return;

  form.addEventListener("submit", function(e) {
    e.preventDefault();
    const entered = input.value.trim();

    if (entered === PASSWORD) {
      try { sessionStorage.setItem("bucolikAccess", "granted"); } catch(e){ console.warn(e); }
      window.location.href = REDIRECT_URL;
    } else {
      if (error) error.style.display = "block";
      input.value = "";
      input.focus();
    }
  });
});
